import { defineComponent as _defineComponent } from 'vue'
import { onMounted, computed } from 'vue';
import { useDonationFormsStore } from '../store';


export default /*@__PURE__*/_defineComponent({
  __name: 'DonationForm',
  props: {
  donation_custom_dropdown: Array,
  currencies: Object,
  amounts: Array,
  strings: Object,
  show_currency_dropdown: Boolean,
  show_custom_dropdown: Boolean,
  show_amounts: Boolean,
  custom_amount: Number,
  show_recurring: Boolean,
  symbols: Object,
  symbol: String,
  display_amount: Number,
  amounts_recurring: Array,
  show_causes_dropdown: Boolean,
  causes_list: Array,
  show_reward_images: Boolean,
  reward_amounts: Array,
  reward_images: Array,
  show_reward_images_recurring: Boolean,
  recurring_rewards: Array,
  recurring_images: Array,
  reward_images_text: String
},
  setup(__props, { expose: __expose }) {
  __expose();

const store = useDonationFormsStore();
const props = __props;

const lifeline_donation = globalThis.lifeline_donation;
const _ = globalThis._;

const setValue = (key: string, val: string | number) => {
  store[key] = val;
};

const getSymbol = () => {
  return props.symbols[store.currency] != undefined ? props.symbols[store.currency] : props.symbol;
};

const convert = (amt: number) => {
  const { exchange_rates } = lifeline_donation;
  const syb = store.currency;
  if (_.get(exchange_rates, syb)) {
    return (_.get(exchange_rates, syb) * amt).toFixed(2);
  }
  return amt;
};

onMounted(() => {
  if (props.show_amounts && _.size(props.amounts)) {
    setValue('amount', props.amounts[0]);
  }
  if (props.show_currency_dropdown && _.size(props.currencies)) {
    setValue('currency', _.keys(props.currencies)[0]);
  }
  if (props.display_amount) {
    store.amount = props.display_amount;
  }
});

const matchingRewardIndex = computed(() => {
  return props.reward_amounts.findIndex(amount => convert(amount) == store.amount);
});

const matchingRecurringRewardIndex = computed(() => {
  return props.recurring_rewards.findIndex(amount => convert(amount) == store.amount);
});

const __returned__ = { store, props, lifeline_donation, _, setValue, getSymbol, convert, matchingRewardIndex, matchingRecurringRewardIndex }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})